// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"InputSearch_searchIcon__Wq_J-"};